import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbar } from '@angular/material/toolbar';

@Component({
  selector: 'shared-header',
  standalone: true,
  imports: [MatToolbar, NgOptimizedImage, RouterLink, TranslatePipe, MatButtonModule, MatMenuModule, MatIconModule, MatDividerModule],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  userName = input<string | null>();
  translatedTitle = input.required<string>();
  showLogout = input<boolean>(false);
  showNotifications = input<boolean>(false);
  menuItems = input<Array<{ label: string; routerLink?: string; action?: string }>>([]);

  logout = output<void>();
  menuAction = output<string>();

  onLogout() {
    this.logout.emit();
  }
}
